import { handleApiRequest } from 'Utils/handleApiRequest';

/*
 * API THUNKS
 * */

/* eslint-disable */

export const listRoomImageProcessors =
  (room_id: number) =>
  async (dispatch: any, _getState = null, utils: any) => {
    try {
      const result = await handleApiRequest(
        dispatch,
        utils.Api.get(`rooms/${room_id}/image-processor`)
      );
      return result;
    } catch (error) {
      console.error('[ImageProcessor Action] API request failed:', error);
      throw error;
    }
  };
